/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Created_SuccessInputs */

const en_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue created successfully`)
};

const fr_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incident cree avec succes`)
};

const de_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem erfolgreich erstellt`)
};

const it_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema creato con successo`)
};

const ru_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблема успешно создана.`)
};

const es_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema creado exitosamente`)
};

const zh_cn2_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题已成功创建`)
};

const ja_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題が正常に作成されました`)
};

const hi_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समस्या सफलतापूर्वक बनाई गई`)
};

const pt_pt2_manual_qc_created_success = /** @type {(inputs: Manual_Qc_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema criado com sucesso`)
};

/**
* | output |
* | --- |
* | "Issue created successfully" |
*
* @param {Manual_Qc_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_created_success = /** @type {((inputs?: Manual_Qc_Created_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Created_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_created_success(inputs)
	if (locale === "de") return de_manual_qc_created_success(inputs)
	if (locale === "it") return it_manual_qc_created_success(inputs)
	if (locale === "ru") return ru_manual_qc_created_success(inputs)
	if (locale === "es") return es_manual_qc_created_success(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_created_success(inputs)
	if (locale === "ja") return ja_manual_qc_created_success(inputs)
	if (locale === "hi") return hi_manual_qc_created_success(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_created_success(inputs)
	return en_manual_qc_created_success(inputs)
});